import React, { useState } from "react";
import { Headline } from "@components/Headline";
import { cx } from "@shared/cx";
import { StyledSection } from "./styles";
import { WORKS } from "./constants";

const WorkSection = ({ ...props }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const tabs = WORKS.map(work => work.company);

  return (
    <StyledSection {...props}>
      <div className="content">
        <Headline text="Work Experiences" />
        <div className="container">
          <div className="info">
            <div className="tabs">
              {tabs.map((tab, index) => (
                <span
                  key={`tab-${index}`}
                  className={currentTab === index ? "selected" : undefined}
                  onClick={() => setCurrentTab(index)}
                >
                  {tab}
                </span>
              ))}
            </div>

            {WORKS.map(
              ({ company, companyHref, positions, techs }, workIndex) => (
                <div
                  key={`tab-content-${workIndex}`}
                  className={`tab-content ${cx(
                    currentTab !== workIndex,
                    "hidden"
                  )}`}
                >
                  {positions.map(({ name, date }, index) => (
                    <div key={`position-${index}`} className="position">
                      <p className="title">
                        {name}{" "}
                        <a
                          href={companyHref}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          @ {company}
                        </a>
                      </p>
                      <span className="date">{date}</span>
                    </div>
                  ))}

                  <ul className="tech-keypoints">
                    {techs.map((point, index) => (
                      <li key={`keypoint-${index}`}>{point}</li>
                    ))}
                  </ul>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </StyledSection>
  );
};

export default WorkSection;
